import { Autocomplete, AutocompleteProps, createFilterOptions, SxProps, TextField, Theme } from '@mui/material';
import { Controller, FieldError } from 'react-hook-form';

interface Props<T, Multiple extends boolean | undefined, FreeSolo extends boolean | undefined> extends Omit<
    AutocompleteProps<T, Multiple, undefined, FreeSolo>,
    'renderInput'
> {
    name: string;
    label?: string;
    placeholder?: string;
    defaultValue: any;
    sx?: SxProps<Theme>;
}

export function ControlledAutocomplete<
    T,
    Multiple extends boolean | undefined = undefined,
    FreeSolo extends boolean | undefined = undefined,
>({ name, label, placeholder, defaultValue, sx, ...autoCompleteProps }: Props<T, Multiple, FreeSolo>) {
    return (
        <Controller
            name={name}
            defaultValue={defaultValue}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <Autocomplete
                    {...autoCompleteProps}
                    id={`${name}-field`}
                    sx={sx}
                    autoComplete={false}
                    onChange={(_, data) => onChange(data)}
                    value={value}
                    filterOptions={createFilterOptions({
                        ignoreCase: true,
                    })}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            placeholder={placeholder}
                            slotProps={{ inputLabel: { ...params.InputLabelProps, shrink: true } }}
                            error={!!error}
                            helperText={
                                error
                                    ? autoCompleteProps.multiple
                                        ? (error as unknown as FieldError[]).filter((error) => !!error)[0]?.message
                                        : error.message
                                    : null
                            }
                        />
                    )}
                />
            )}
        />
    );
}
